// Legacy /safety/:page slugs and the /pages/safety/:name record each one
// opens. Kept out of the redirect component so the route loader can use it
// without waiting for the component's chunk.
const SAFETY_PATH_MAP = {
  "tss-applicability-chart": "tss-applicability-chart",
  features: "features",
  adas: "adas",
  resources: "resources",
  // Retired Overview page → land on the default tab.
  overview: "tss-applicability-chart",
};

// The dropped Overview tab and any unknown page fall back to the TSS
// Applicability Chart tab.
const DEFAULT_PAGE = "tss-applicability-chart";

export const safetyPageName = (page) => SAFETY_PATH_MAP[page] || DEFAULT_PAGE;
